import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import logo from "../assets/images/Logo.png";

const Menu = ({ toggleMenu, activeLink, handleLinkClick }) => {
  const location = useLocation();
  const closeMenu = () => {
    toggleMenu();
  };

  const isLinkActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="menu-page">
      <div className="menu-icon">
        <div className="app__navbar-logo">
          <a href="#home" className="nav-xbtext">
            <img src={logo} alt="site-logo" />
            <span>UrchDev</span>
          </a>
        </div>
        <HiX onClick={closeMenu} className="cursor-pointer w-[50px] h-[40px]" />
      </div>

      <AnimatePresence>
        <motion.ul
          className="menu-page-links"
          initial="hidden"
          animate="visible"
          exit="hidden"
        >
          <motion.li
            key=""
            variants={{
              hidden: { opacity: 0, x: 100 },
              visible: { opacity: 1, x: 0, transition: { delay: 0.2 } },
            }}
          >
            <div />
            <a
              href="/#home"
              className={`nav-bbtext ${
                activeLink === "home" ? "active-link" : ""
              } `}
              onClick={() => {
                handleLinkClick("home");
                closeMenu();
              }}
            >
              Home
            </a>
          </motion.li>

          <motion.li
            key=""
            variants={{
              hidden: { opacity: 0, x: 100 },
              visible: { opacity: 1, x: 0, transition: { delay: 0.2 } },
            }}
          >
            <div />
            <a
              href="/#projects"
              className={`nav-bbtext ${
                activeLink === "projects" ? "active-link" : ""
              } `}
              onClick={() => {
                handleLinkClick("projects");
                closeMenu();
              }}
            >
              Projects
            </a>
          </motion.li>

          <motion.li
            key=""
            variants={{
              hidden: { opacity: 0, x: 100 },
              visible: { opacity: 1, x: 0, transition: { delay: 0.2 } },
            }}
          >
            <div />
            <a
              href="/#about-me"
              className={`nav-bbtext ${
                activeLink === "about" ? "active-link" : ""
              } `}
              onClick={() => {
                handleLinkClick("about");
                closeMenu();
              }}
            >
              About-me
            </a>
          </motion.li>

          <motion.li
            key=""
            variants={{
              hidden: { opacity: 0, x: 100 },
              visible: { opacity: 1, x: 0, transition: { delay: 0.2 } },
            }}
          >
            <div />
            <a
              href="/#contact"
              className={`nav-bbtext ${
                activeLink === "contact" ? "active-link" : ""
              } `}
              onClick={() => {
                handleLinkClick("contact");
                closeMenu();
              }}
            >
              Contact
            </a>
          </motion.li>
        </motion.ul>
      </AnimatePresence>
    </div>
  );
};

export default Menu;
